import React, { useEffect, useState } from "react";
import TutorialExpenseTable from "./expenseTable";
import EPopup from "../expensePopup";
import "reactjs-popup/dist/index.css";
import "../../styling/sidebar.css";
import { Container, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import Popup from "reactjs-popup";
import AuthService from "../../services/auth";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import * as Scroll from "react-scroll";
import { ReactComponent as PlusIcon } from "../../assets/sidebaricons/plusIcon.svg";
import "./styling/style.css";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Card } from "@material-ui/core";
import Alert from "react-bootstrap/Alert";
import { ReactComponent as HandIcon } from "../../assets/handIcon.svg";
import { ReactComponent as NextIcon } from "../../assets/nextIcon.svg";
import PermanentDrawerLeft from "./tutorialSidebar";
import Mode from "../Mode";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import SelectDropdown from "../UI/SelectDropdown";
import { createData2, percentage, round } from "../PieChart";
import useWindowSize from "../../hooks/useWindowSize";
import ReactGA from "react-ga";
import Dropdown from "react-bootstrap/Dropdown";
import { ReactComponent as CsvImportIcon } from "../../assets/csvImportIcon.svg";
import { ReactComponent as ExcelImportIcon } from "../../assets/excelImportIcon.svg";
import Chart from "react-apexcharts";
import { CloseIconWithTooltip } from "./tutorialLanding";
import Etsy from "../../assets/etsyLogo.png";

interface CustomizedState {
  stream: number;
  pathData: string;
  isLastStep: boolean;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#48B7A7",
    },
    background: {
      paper: "#E8F9FD",
    },
  },
});

function TutorialStream() {
  var total = 0;
  var scroll = Scroll.animateScroll;
  const location = useLocation();
  const history = useHistory();
  const [sidebar, setSidebar] = useState(false);
  const { width = 0 } = useWindowSize();
  const statevars = location.state as CustomizedState;
  const currentPagePath = location.pathname;
  ReactGA.pageview(window.location.pathname);
  const [isReplay, setIsReplay] = useState(
    history.location.search.includes("replay=true") ||
      history.location.pathname.includes("replay=true"),
  );

  const ucats = ["General", "Equipment", "Materials", "Tools"];

  const sale = 135;

  const [option, setOption] = useState("expense");

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
    //this.setState({currUser:currUser, userReady:true})
  }
  componentMounted();

  const cache = createCache({
    key: "css",
    prepend: false,
  });

  const [step5, setStep5] = useState(true);
  const [step6, setStep6] = useState(false);
  const [step7, setStep7] = useState(false);
  const [step7new, setStep7new] = useState(false);
  const [step8, setStep8] = useState(false);
  const [stepCalcPricing, setStepCalcPricing] = useState(false);
  const [checkEtsySource, setCheckEtsySource] = useState(false);
  const [completeTutorial, setCompleteTutorial] = useState(false);
  const isEstySelected = localStorage.getItem("etsyIndicated");

  const dict = {
    "Hand Plan": 4,
    "Oak 4x4x4": 23,
    "Dado blade": 41,
    "Dark walnut stain": 13,
  };

  const showstep6 = () => {
    setStep5(false);
    setStep6(true);
  };
  const showstep7 = () => {
    setStep6(false);
    setStep7(true);
    scroll.scrollTo(400);
  };

  useEffect(() => {
    if (statevars.isLastStep) {
      if (isEstySelected) {
        setCheckEtsySource(true);
      } else {
        setCompleteTutorial(true);
      }
      setStepCalcPricing(false);
      setStepCalcPricing(false);
      setStep5(false);
    }
  }, [statevars]);

  const showStepCalcPricing = () => {
    history.push(`/tutorial_stream/${statevars.pathData}/calculator`, {
      state: { isTutorial: true, prevPagePath: currentPagePath },
    });
  };

  const handleClose = () => {
    history.push("/");
  };

  const showstep8 = () => {
    setStep7(false);
    setStep8(true);
    const ele = document.getElementById("bottom-page");
    if (ele)
      ele.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    scroll.scrollToBottom();
  };

  const showstep7new = () => {
    setStep7(false);
    setStep7new(false);
    const ele = document.getElementById("income-stream-overview");
    if (ele)
      ele.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };
    }, 500);
  }, []);

  const options = {
    chart: {
      width: 300,
      type: "pie",
      events: {},
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
      },
    },
    colors: ["#21A179", "#7964D9", "#EB6F2D", "#98B514", "#0DA4B5"],
    labels: ["Hand Plan", "Oak 4x4x4", "", "Dado blade", "Dark walnut stain"],
    states: {
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    tooltip: {
      y: {},
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  const series = [4, 23, 41, 13];

  const popoverS5 = (
    <Popover
      id="popover-basic3"
      style={{ maxWidth: 424 }}
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Analytics</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        You can see general analytics for the selected business.
      </Popover.Content>
      <Button onClick={showstep6} className="popover-button">
        Next{" "}
      </Button>
    </Popover>
  );

  const popoverS6 = (
    <Popover id="popover-basic4" className="all-popover">
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Analytics</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        Log individual expenses or import CSV/Excel files of existing expenses.
      </Popover.Content>
      <Button onClick={showstep7} className="popover-button">
        Next{" "}
      </Button>
    </Popover>
  );

  const popoverCalcPricing = (
    <Popover id="popover-basic4" className="all-popover">
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Pricing Calculators</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        Calculators are autofilled with platform fees.
      </Popover.Content>
      <Button onClick={showStepCalcPricing} className="popover-button">
        {isEstySelected ? "Next" : "Finish"}
      </Button>
    </Popover>
  );

  const popoverS7new = (
    <Popover id="popover-basic5" className="all-popover">
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Sales Log</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        Manage and categorize your sales here.
      </Popover.Content>
      <Button onClick={showstep8} className="popover-button">
        Next{" "}
      </Button>
    </Popover>
  );

  return (
    <>
      <ThemeProvider theme={theme}>
        <CacheProvider value={cache}>
          <Container fluid>
            <Row>
              <PermanentDrawerLeft
                setCheckEtsySource={setCheckEtsySource}
                checkEtsySource={checkEtsySource}
                completeTutorial={completeTutorial}
                setCompleteTutorial={setCompleteTutorial}
              />
              <Col
                className={
                  sidebar
                    ? `overview-section income-streams-container p-0`
                    : `overview-section income-streams-container p-0 sidebar-collapse`
                }
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <div className="row">
                      <div
                        className="income-stream-overview"
                        id="income-stream-overview"
                      >
                        Cameron’s Jewelry &nbsp;
                        <OverlayTrigger
                          show={step5}
                          placement="bottom"
                          overlay={popoverS5}
                        >
                          <span>Shop</span>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div className="row">
                      <div className="streamsource">
                        <img src={Etsy} alt="Etsy" />
                      </div>
                    </div>

                    <div className="row">
                      <div>
                        <b className="total-expense">Total Expenses:</b> $0.00
                      </div>
                    </div>
                    <div className="total-sale-row row">
                      <div className="totalexpensesale">
                        <b className="total-expense">Total Sales:</b> $
                        {sale.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      {option == "expense" && (
                        <Popup
                          trigger={
                            <OverlayTrigger
                              show={step6}
                              placement="left"
                              overlay={popoverS6}
                            >
                              <button className="expensebutton ml-3" disabled>
                                <PlusIcon />
                                <span className="bussiness-page-button pl-1">
                                  Add Expense{" "}
                                </span>
                              </button>
                            </OverlayTrigger>
                          }
                          modal
                          nested
                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="header"> Add Sales </div>
                              <div className="content">
                                {" "}
                                <EPopup
                                  stream={statevars?.stream}
                                  categories={ucats}
                                />
                                <br />
                              </div>
                            </div>
                          )}
                        </Popup>
                      )}

                      <button className="expensebutton " disabled>
                        <PlusIcon />
                        <span className="bussiness-page-button pl-1">
                          Add Sales{" "}
                        </span>
                      </button>

                      <OverlayTrigger
                        show={stepCalcPricing}
                        placement="bottom"
                        overlay={popoverCalcPricing}
                      >
                        <button className="expensebutton " disabled>
                          <PlusIcon />
                          <span className="bussiness-page-button pl-1">
                            Calculate Pricing{" "}
                          </span>
                        </button>
                      </OverlayTrigger>
                    </div>

                    <Row className="d-flex justify-content-start ml-2">
                      <div className="excel-csv-dropdown ml-3">
                        <Dropdown>
                          <Dropdown.Toggle
                            style={{
                              borderRadius: "6px",
                              boxShadow: "0 0 40px rgb(0 0 0 / 0%)",
                            }}
                          >
                            Import Expenses
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <CsvImportIcon />
                              Import from CSV
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <ExcelImportIcon />
                              Import from XLS
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="excel-csv-dropdown ml-3">
                        <Dropdown>
                          <Dropdown.Toggle
                            style={{
                              borderRadius: "6px",
                              boxShadow: "0 0 40px rgb(0 0 0 / 0%)",
                            }}
                          >
                            Import Sales
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <CsvImportIcon />
                              Import from CSV
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <ExcelImportIcon />
                              Import from XLS
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Row>
                  </div>
                </div>
                <div>
                  <Row className="d-flex justify-content-between">
                    <Alert
                      key="success"
                      variant="success"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-3">
                          Miniature Strawberry Earrings was your top selling
                          product of the week.
                        </div>
                      </div>
                    </Alert>
                    <Alert
                      key="success"
                      variant="success"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-3">
                          Miniature Fruit Earrings was your top selling
                          collection of the week.
                        </div>
                      </div>
                    </Alert>
                    <Alert
                      key="danger"
                      variant="danger"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-3">
                          Poly mailer envelopers were your biggest source of
                          expenses this week.{" "}
                        </div>
                      </div>
                    </Alert>
                    <NextIcon className="ml-3 mt-4" />
                  </Row>
                </div>
                <Row className="income-stream-tabs ml-0">
                  <Tabs
                    sx={{ marginLeft: 0, marginBottom: 4 }}
                    value="expense"
                    className="ml-3"
                  >
                    <Tab
                      label="Expense Tracker"
                      value="expense"
                      className="all-tabs"
                      sx={{
                        fontWeight: 600,
                        textTransform: "capitalize",
                        fontSize: 18,
                      }}
                    />
                    <Tab
                      label={
                        <OverlayTrigger
                          show={step7}
                          placement="top-start"
                          overlay={popoverS7new}
                        >
                          <span>Sales Log</span>
                        </OverlayTrigger>
                      }
                      value="sales"
                      className="all-tabs"
                      sx={{
                        fontWeight: 600,
                        textTransform: "capitalize",
                        fontSize: 18,
                      }}
                    />
                    <Tab
                      label="Saved Pricing Calculations"
                      value="saved"
                      className="all-tabs"
                      sx={{
                        fontWeight: 600,
                        textTransform: "capitalize",
                        fontSize: 18,
                      }}
                    />
                  </Tabs>
                </Row>

                <div
                  className={`mb-5 ${
                    sidebar ? `piechart-section-sidebar` : `piechart-section `
                  }`}
                >
                  {option == "expense" && (
                    <Row className={`d-flex expense-piechart-actions`}>
                      <div className="mt-3">
                        {option == "expense" && (
                          <>
                            <div className="d-flex flex-wrap">
                              <FormControl className="justify-content-center">
                                <RadioGroup
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                  value={1}
                                >
                                  <FormControlLabel
                                    value={1}
                                    className="mb-1 radio-btn"
                                    control={<Radio />}
                                    label="Percentage Breakdown"
                                  />
                                  <FormControlLabel
                                    value={2}
                                    className="mb-0 mt-1 radio-btn"
                                    control={<Radio />}
                                    label="Time Breakdown"
                                  />
                                </RadioGroup>
                              </FormControl>
                              <div className="d-flex flex-column">
                                <div className="my-1">
                                  <SelectDropdown
                                    label="Pie Chart Type"
                                    width={200}
                                    disabled
                                    value={0}
                                    options={[
                                      {
                                        value: 0,
                                        label: "Category",
                                      },
                                      {
                                        value: 1,
                                        label: "Purchased From",
                                      },
                                      {
                                        value: 2,
                                        label: "Product Name",
                                      },
                                    ]}
                                  />
                                </div>

                                <div className="my-1">
                                  <SelectDropdown
                                    label="Expense Filter"
                                    width={200}
                                    isDisable
                                    value={0}
                                    options={[
                                      {
                                        value: 0,
                                        label: "All Time",
                                      },
                                      {
                                        value: 1,
                                        label: "Last Week",
                                      },
                                      {
                                        value: 2,
                                        label: "Last Month",
                                      },
                                      {
                                        value: 3,
                                        label: "Last 60 Days",
                                      },
                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Row>
                  )}

                  <Row className="py-4">
                    {option == "expense" && (
                      <Col
                        className="text-center d-flex justify-content-center"
                        md={8}
                      >
                        <div>
                          <h4 className="graph-header">
                            View Percentage Breakdown of Expenses
                          </h4>
                          <Chart
                            // @ts-ignore
                            options={options}
                            series={series}
                            type="pie"
                            height={300}
                          />
                        </div>
                      </Col>
                    )}
                    <Col>
                      <div className="card-section mt-5">
                        <Card className="card-content">
                          <div className="pl-2 card-main-content">
                            {Object.keys(dict).map((nrow, index) => {
                              let data = createData2(nrow, dict[nrow], index);
                              return (
                                data.label.length > 0 && (
                                  <>
                                    <div
                                      className="piechart-legends"
                                      key={index}
                                    >
                                      <p
                                        style={{
                                          // boxes of color in the legend
                                          backgroundColor: data.color,
                                          width: 20,
                                          height: 20,
                                          marginBottom: 10,
                                        }}
                                      />
                                      <p className="name-content">
                                        {percentage(data.subLabel, 81)} -
                                        {data.label.length > 10
                                          ? data.label.slice(0, 10) + "..."
                                          : data.label}
                                      </p>
                                    </div>
                                  </>
                                )
                              );
                            })}
                          </div>
                        </Card>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row>
                  {option == "expense" && !step8 && (
                    <div className="streams  mb-5 mt-5">
                      <TutorialExpenseTable
                        stream={statevars?.stream}
                        categories={ucats}
                        setCheckEtsySource={setCheckEtsySource}
                        checkEtsySource={checkEtsySource}
                        completeTutorial={completeTutorial}
                        setCompleteTutorial={setCompleteTutorial}
                      />
                    </div>
                  )}
                  {option == "expense" && step8 && (
                    <div
                      className="streams mb-5"
                      id="tutorialExpenseTable-strem"
                    >
                      <TutorialExpenseTable
                        step={true}
                        stream={statevars?.stream}
                        categories={ucats}
                        setCheckEtsySource={setStepCalcPricing}
                        checkEtsySource={checkEtsySource}
                        completeTutorial={completeTutorial}
                        setCompleteTutorial={setStepCalcPricing}
                      />
                    </div>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </CacheProvider>
      </ThemeProvider>
      <Mode />
    </>
  );
}

export default TutorialStream;
